<template>
    <modal-template>
        <div slot="header">
            {{ trans('users.label.new_login') }}
        </div>

        <div slot="body">
            <alert class="h:margin-bottom-8" type="warning">
                <div>
                    {{ trans('users.note.new_login') }}<br><br>
                    {{ trans('users.note.last_login', {'date': last_login}) }}
                </div>
            </alert>

            <div class="form form-section">
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <input type="radio" class="radio" name="action" v-model="selected" value="resetPassword" @change="showButton" id="reset_password"/>
                        <label for="reset_password">
                            {{ trans('users.label.reset_password') }}
                        </label>
                    </div>

                    <div class="form-row__col form-row__col--one-half">
                        <input type="radio" class="radio" name="action" v-model="selected" value="welcomeMail" @change="showButton" id="welcome_mail"/>
                        <label for="welcome_mail">
                            {{ trans('emails.index.welcome_mail')}}
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button type="button" @click="$emit('close')" class="btn btn--secondary">{{ trans('buttons.cancel') }}</button>
            <button type="button" :disabled="!show" @click="submit" class="btn btn--primary">{{ trans('buttons.ok') }}</button>
        </div>
    </modal-template>
</template>

<script>
export default {
    props: {
        user_id: {
            type: Number,
            required: true
        },
        last_login: {
            type: String,
            default: '-'
        }
    },

    data() {
        return {
            show: false,
            selected: null,
        }
    },

    computed: {
        urlPrefix() {
            if (location.pathname == '/main/managers') {
                return 'mainapi.managers';
            }
            return 'tenantapi.users';

        }
    },

    methods: {
        showButton() {
            this.show = true;
        },

        submit() {
            var url = '';
            if (this.selected == 'welcomeMail') {
                url = this.route(this.urlPrefix + '.welcomemail', this.user_id);
            } else if (this.selected == 'resetPassword') {
                url = this.route(this.urlPrefix + '.password.reset', this.user_id);
            }

            axios
            .get(url)
            .then((response) => {
                this.flash(response);

                // Close modal
                this.$emit('close');
            })
            .catch(error => {
                // Get validation error messages
                console.log(error);
            });
        }
    }
}
</script>
